import BookmarkIcon from '@mui/icons-material/Bookmark';
import DeleteIcon from '@mui/icons-material/Delete';
import { Tooltip } from '@mui/material';

const SubtitleIconRightColumn = ({ index, rowData, updateSub, removeSub, readOnly }) => (
    <div
        id={`icon${index}`}
        style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            width: '30px',
        }}
    >
        <Tooltip title={readOnly ? 'Read-only: bookmarking is locked' : 'Toggle bookmark'} placement="left">
            <BookmarkIcon
                id={`bookmarkIcon${index}`}
                style={{
                    fontSize: '19px',
                    marginRight: '10px',
                    cursor: readOnly ? 'not-allowed' : 'pointer',
                    opacity: readOnly ? 0.5 : 1,
                    color: rowData?.bookmark ? 'orange' : null,
                }}
                onClick={() => {
                    if (readOnly || !rowData) return;

                    const isBookmarked = rowData.bookmark;

                    updateSub(rowData, {
                        bookmark: !isBookmarked,
                    });
                }}
            />
        </Tooltip>

        <Tooltip title={readOnly ? 'Read-only: delete is locked' : 'Delete subtitle'} placement="left">
            <DeleteIcon
                id={`deleteIcon${index}`}
                style={{
                    fontSize: '19px',
                    marginRight: '10px',
                    cursor: readOnly ? 'not-allowed' : 'pointer',
                    opacity: readOnly ? 0.5 : 1,
                }}
                onClick={() => {
                    if (readOnly) return;
                    removeSub(rowData);
                }}
            />
        </Tooltip>
    </div>
);

export default SubtitleIconRightColumn;
